
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/commercial-and-industrial-excavation-sydney/underground-basement-excavation-sydney",
      function () {
        return require("private-next-pages/services/commercial-and-industrial-excavation-sydney/underground-basement-excavation-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/commercial-and-industrial-excavation-sydney/underground-basement-excavation-sydney"])
      });
    }
  